import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { PersistGate } from 'redux-persist/integration/react';
import getAppStoreObject from './store/store';
import { Provider } from 'react-redux';
import Loading from './components/loading/loading';
import LogRocket from 'logrocket';
import ReactGA from 'react-ga4';
import { createBrowserHistory } from 'history';

if (window.appSettings.GOOGLE_ANLYTICS_CODE) {
    ReactGA.initialize(window.appSettings.GOOGLE_ANLYTICS_CODE);
}
LogRocket.init('whxqqa/alms');
const history = createBrowserHistory();

// get redux store and persistor
const storeObject = getAppStoreObject(history);

ReactDOM.render(
    <Provider store={storeObject.reduxStore}>
        <Loading spinnerId={'LoadingMain'} top={'40%'} width={100} />
        <PersistGate loading={<div>Yükleniyor...</div>} persistor={storeObject.storePersistor}>
            <App history={history} />
        </PersistGate>
    </Provider>, document.getElementById('root')
);

// if you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
